import { render, staticRenderFns } from "./OngoingTravels.vue?vue&type=template&id=2f2d5ac4&scoped=true&"
import script from "./OngoingTravels.vue?vue&type=script&lang=js&"
export * from "./OngoingTravels.vue?vue&type=script&lang=js&"
import style0 from "./OngoingTravels.vue?vue&type=style&index=0&id=2f2d5ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d5ac4",
  null
  
)

export default component.exports